import { AlertCircle, Inbox, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

const stateConfig = {
  loading: { Icon: Loader2, className: "animate-spin", text: "Đang tải dữ liệu..." },
  empty: { Icon: Inbox, className: "", text: "Không có dữ liệu" },
  error: { Icon: AlertCircle, className: "text-red-600", text: "Không tải được dữ liệu" },
};

function DataStateContent({ type, message, onRetry }) {
  const { Icon, className, text } = stateConfig[type] || stateConfig.empty;
  return (
    <div className="flex flex-col items-center justify-center gap-2 text-center">
      <Icon className={cn("w-5 h-5 text-stone-400", className)} />
      <div className="text-sm text-stone-500">{message || text}</div>
      {type === "error" && onRetry && (
        <Button type="button" variant="outline" size="sm" onClick={onRetry} className="rounded-sm">
          Thử lại
        </Button>
      )}
    </div>
  );
}

export function DataStateRow({ colSpan, type, message, onRetry }) {
  return (
    <tr>
      <td colSpan={colSpan} className="px-4 py-8">
        <DataStateContent type={type} message={message} onRetry={onRetry} />
      </td>
    </tr>
  );
}

export function DataStatePanel({ type, message, onRetry, className }) {
  return (
    <div className={cn("bg-white border border-stone-200 rounded-sm px-4 py-10", className)}>
      <DataStateContent type={type} message={message} onRetry={onRetry} />
    </div>
  );
}
